var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUndrawBrainstormingGny9(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 800.385,
    height: 475.927,
    viewBox: "0 0 800.385 475.927",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    artist: "Katerina Limpitsouni",
    source: "https://undraw.co/",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-675.225 -304.907)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1393.713 682.811)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M474.415,539.509v1.424a8.91,8.91,0,0,0,8.9,8.9H547.41a8.9,8.9,0,0,0,8.9-8.9v-1.424a8.838,8.838,0,0,0-2.065-5.7,9.158,9.158,0,0,0-1.5-1.424s-35.237-.8-35.237-1.78h-34.19a8.914,8.914,0,0,0-8.9,8.9Z",
    transform: "translate(-474.415 -530.607)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 9.258,
    height: 59.82,
    transform: "translate(36.835 18.874)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.807,637.043c0,1-14.029.387-31.334.387s-31.334.613-31.334-.387,14.029-8.933,31.334-8.933S550.807,636.043,550.807,637.043Z",
    transform: "translate(-478.366 -558.674)",
    fill: "#ccc"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 620.283,
    height: 344.882,
    rx: 6,
    transform: "translate(675.225 304.907)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 599.438,
    height: 321.511,
    rx: 4,
    transform: "translate(685.962 316.909)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(749.133 398.194)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M715.868,359.024A3.522,3.522,0,0,1,715.21,356a83.447,83.447,0,0,0,0-38.759,3.524,3.524,0,0,1,.659-3.022A3.464,3.464,0,0,1,718.6,312.9h32.518a3.509,3.509,0,0,1,3.456,2.941,136.6,136.6,0,0,1,0,41.573,3.509,3.509,0,0,1-3.456,2.941H718.6A3.465,3.465,0,0,1,715.868,359.024Z",
    transform: "translate(-715.109 -312.895)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M747.36,333.279H730.23a2.41,2.41,0,0,1-2.407-2.407V329.85a2.41,2.41,0,0,1,2.407-2.407h17.13a2.41,2.41,0,0,1,2.407,2.407v1.022A2.41,2.41,0,0,1,747.36,333.279Z",
    transform: "translate(-717.622 -315.77)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M747.36,345.827H730.23a2.41,2.41,0,0,1-2.407-2.407V342.4a2.41,2.41,0,0,1,2.407-2.407h17.13a2.41,2.41,0,0,1,2.407,2.407v1.022A2.41,2.41,0,0,1,747.36,345.827Z",
    transform: "translate(-717.622 -318.25)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M878.278,273.606H351.708a.87.87,0,1,1,0-1.741h526.57a.87.87,0,0,1,0,1.741Z",
    transform: "translate(370.233 81.212)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.708,526.585a.87.87,0,0,1-.87-.87V239.366a.87.87,0,0,1,1.741,0V525.715a.87.87,0,0,1-.87.87Z",
    transform: "translate(348.066 85.538)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M673.708,526.585a.87.87,0,0,1-.87-.87V239.366a.87.87,0,0,1,1.741,0V525.715A.87.87,0,0,1,673.708,526.585Z",
    transform: "translate(328.491 85.538)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M824.708,526.585a.87.87,0,0,1-.87-.87V239.366a.87.87,0,0,1,1.741,0V525.715a.87.87,0,0,1-.87.87Z",
    transform: "translate(308.915 85.538)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M796.434,422.326h-31.8a3.921,3.921,0,0,1-3.917-3.917V380.88a3.921,3.921,0,0,1,3.917-3.917h31.8a3.921,3.921,0,0,1,3.917,3.917v37.53A3.921,3.921,0,0,1,796.434,422.326Z",
    transform: "translate(317.098 67.587)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M725.434,438.326h-31.8a3.921,3.921,0,0,1-3.917-3.917V396.88a3.921,3.921,0,0,1,3.917-3.917h31.8a3.921,3.921,0,0,1,3.917,3.917v37.53A3.921,3.921,0,0,1,725.434,438.326Z",
    transform: "translate(326.301 65.513)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.434,506.326h-31.8a3.921,3.921,0,0,1-3.917-3.917V464.88a3.921,3.921,0,0,1,3.917-3.917h31.8a3.921,3.921,0,0,1,3.917,3.917v37.53A3.921,3.921,0,0,1,572.434,506.326Z",
    transform: "translate(346.137 56.697)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.434,449.326h-31.8a3.921,3.921,0,0,1-3.917-3.917V407.88a3.921,3.921,0,0,1,3.917-3.917h31.8a3.921,3.921,0,0,1,3.917,3.917v37.53A3.921,3.921,0,0,1,387.434,449.326Z",
    transform: "translate(370.12 64.087)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.433,370.326h-31.8a3.921,3.921,0,0,1-3.917-3.917V328.88a3.921,3.921,0,0,1,3.917-3.917h31.8a3.921,3.921,0,0,1,3.917,3.917v37.53A3.921,3.921,0,0,1,490.433,370.326Z",
    transform: "translate(356.767 74.328)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.93,256.458H408.32a3.481,3.481,0,0,1,0-6.963H457.93a3.481,3.481,0,0,1,0,6.963Z",
    transform: "translate(363.234 84.112)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618.93,256.458H569.32a3.481,3.481,0,0,1,0-6.963H618.93a3.481,3.481,0,0,1,0,6.963Z",
    transform: "translate(342.36 84.112)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M769.93,256.458H720.32a3.481,3.481,0,0,1,0-6.963H769.93a3.481,3.481,0,0,1,0,6.963Z",
    transform: "translate(322.787 84.112)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M910.93,256.458H861.32a3.481,3.481,0,0,1,0-6.963H910.93a3.481,3.481,0,0,1,0,6.963Z",
    transform: "translate(304.507 84.112)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.839, -0.545, 0.545, 0.839, 1322.437, 654.695)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.659,40a3.054,3.054,0,0,1-.571-2.62,72.358,72.358,0,0,0,0-33.608A3.056,3.056,0,0,1,.659,1.15,3,3,0,0,1,3.031,0h28.2a3.042,3.042,0,0,1,3,2.55,118.444,118.444,0,0,1,0,36.048,3.042,3.042,0,0,1-3,2.55H3.031A3,3,0,0,1,.659,40Z",
    transform: "translate(0 0)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.941,5.061H2.087A2.09,2.09,0,0,1,0,2.974V2.087A2.089,2.089,0,0,1,2.087,0H16.941a2.089,2.089,0,0,1,2.087,2.087v.886A2.089,2.089,0,0,1,16.941,5.061Z",
    transform: "translate(8.846 10.122)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.941,5.061H2.087A2.09,2.09,0,0,1,0,2.974V2.087A2.089,2.089,0,0,1,2.087,0H16.941a2.09,2.09,0,0,1,2.087,2.087v.886A2.089,2.089,0,0,1,16.941,5.061Z",
    transform: "translate(8.846 18.851)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M949.434,361.326h-31.8a3.921,3.921,0,0,1-3.917-3.917V319.88a3.921,3.921,0,0,1,3.917-3.917h31.8a3.921,3.921,0,0,1,3.917,3.917v37.53A3.921,3.921,0,0,1,949.434,361.326Z",
    transform: "translate(297.264 75.495)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M920.434,438.326h-31.8a3.921,3.921,0,0,1-3.917-3.917V396.88a3.921,3.921,0,0,1,3.917-3.917h31.8a3.921,3.921,0,0,1,3.917,3.917v37.53A3.921,3.921,0,0,1,920.434,438.326Z",
    transform: "translate(301.023 65.513)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(804.115 508.185)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M715.868,359.024A3.522,3.522,0,0,1,715.21,356a83.447,83.447,0,0,0,0-38.759,3.524,3.524,0,0,1,.659-3.022A3.464,3.464,0,0,1,718.6,312.9h32.518a3.509,3.509,0,0,1,3.456,2.941,136.6,136.6,0,0,1,0,41.573,3.509,3.509,0,0,1-3.456,2.941H718.6A3.465,3.465,0,0,1,715.868,359.024Z",
    transform: "translate(-715.109 -312.895)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M747.36,333.279H730.23a2.41,2.41,0,0,1-2.407-2.407V329.85a2.41,2.41,0,0,1,2.407-2.407h17.13a2.41,2.41,0,0,1,2.407,2.407v1.022A2.41,2.41,0,0,1,747.36,333.279Z",
    transform: "translate(-717.622 -315.77)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M747.36,345.827H730.23a2.41,2.41,0,0,1-2.407-2.407V342.4a2.41,2.41,0,0,1,2.407-2.407h17.13a2.41,2.41,0,0,1,2.407,2.407v1.022A2.41,2.41,0,0,1,747.36,345.827Z",
    transform: "translate(-717.622 -318.25)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(936.486 419.777)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M715.868,359.024A3.522,3.522,0,0,1,715.21,356a83.447,83.447,0,0,0,0-38.759,3.524,3.524,0,0,1,.659-3.022A3.464,3.464,0,0,1,718.6,312.9h32.518a3.509,3.509,0,0,1,3.456,2.941,136.6,136.6,0,0,1,0,41.573,3.509,3.509,0,0,1-3.456,2.941H718.6A3.465,3.465,0,0,1,715.868,359.024Z",
    transform: "translate(-715.109 -312.895)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M747.36,333.279H730.23a2.41,2.41,0,0,1-2.407-2.407V329.85a2.41,2.41,0,0,1,2.407-2.407h17.13a2.41,2.41,0,0,1,2.407,2.407v1.022A2.41,2.41,0,0,1,747.36,333.279Z",
    transform: "translate(-717.622 -315.77)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M747.36,345.827H730.23a2.41,2.41,0,0,1-2.407-2.407V342.4a2.41,2.41,0,0,1,2.407-2.407h17.13a2.41,2.41,0,0,1,2.407,2.407v1.022A2.41,2.41,0,0,1,747.36,345.827Z",
    transform: "translate(-717.622 -318.25)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1026.853 378.922)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M715.868,359.024A3.522,3.522,0,0,1,715.21,356a83.447,83.447,0,0,0,0-38.759,3.524,3.524,0,0,1,.659-3.022A3.464,3.464,0,0,1,718.6,312.9h32.518a3.509,3.509,0,0,1,3.456,2.941,136.6,136.6,0,0,1,0,41.573,3.509,3.509,0,0,1-3.456,2.941H718.6A3.465,3.465,0,0,1,715.868,359.024Z",
    transform: "translate(-715.109 -312.895)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M747.36,333.279H730.23a2.41,2.41,0,0,1-2.407-2.407V329.85a2.41,2.41,0,0,1,2.407-2.407h17.13a2.41,2.41,0,0,1,2.407,2.407v1.022A2.41,2.41,0,0,1,747.36,333.279Z",
    transform: "translate(-717.622 -315.77)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M747.36,345.827H730.23a2.41,2.41,0,0,1-2.407-2.407V342.4a2.41,2.41,0,0,1,2.407-2.407h17.13a2.41,2.41,0,0,1,2.407,2.407v1.022A2.41,2.41,0,0,1,747.36,345.827Z",
    transform: "translate(-717.622 -318.25)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1153.278 384.372)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M715.868,359.024A3.522,3.522,0,0,1,715.21,356a83.447,83.447,0,0,0,0-38.759,3.524,3.524,0,0,1,.659-3.022A3.464,3.464,0,0,1,718.6,312.9h32.518a3.509,3.509,0,0,1,3.456,2.941,136.6,136.6,0,0,1,0,41.573,3.509,3.509,0,0,1-3.456,2.941H718.6A3.465,3.465,0,0,1,715.868,359.024Z",
    transform: "translate(-715.109 -312.895)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M747.36,333.279H730.23a2.41,2.41,0,0,1-2.407-2.407V329.85a2.41,2.41,0,0,1,2.407-2.407h17.13a2.41,2.41,0,0,1,2.407,2.407v1.022A2.41,2.41,0,0,1,747.36,333.279Z",
    transform: "translate(-717.622 -315.77)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M747.36,345.827H730.23a2.41,2.41,0,0,1-2.407-2.407V342.4a2.41,2.41,0,0,1,2.407-2.407h17.13a2.41,2.41,0,0,1,2.407,2.407v1.022A2.41,2.41,0,0,1,747.36,345.827Z",
    transform: "translate(-717.622 -318.25)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1295.508 537.788)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M603.379,75.5l-2.121-13.259,14.32-5.834L617.7,76.565Z",
    transform: "translate(-486.178 -19.628)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M663.892,224.507c-4.844,3.168-10.4,3.237-12.42.154s.277-8.149,5.123-11.317a14.484,14.484,0,0,1,6.416-2.374L683.7,197.806l5.97,9.842L668.64,219.58a14.485,14.485,0,0,1-4.748,4.927Z",
    transform: "translate(-585.253 -83.579)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634.389,95.355h0a12.514,12.514,0,0,1,11.181,15.238L636.937,148.7,597.2,171.929l-4.891-12.43,27.1-20.173,1.451-32.064A12.514,12.514,0,0,1,634.389,95.355Z",
    transform: "translate(-509.464 -37.223)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M782.218,339.617,773.8,352.2l-1.566,3.943-4.614,2.918-17.5-8.124,3.792-8.3,11.362.75,4.669-7.163Z",
    transform: "translate(-732.232 -146.184)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M786.961,351.356l.174,1.735,20.188,5.429s-5.391,7.174-6.292,8.667-29.263-15.634-33.17-18.808-.193-6.228-.193-6.228l22.757,2.31-3.465,6.9h0Z",
    transform: "translate(-766.073 -148.865)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M685.6,208.2l2.241,5.3s4.89,15.079-20.173,20.377-38.1,3.057-38.1,3.057l-43.2,51.757-11-9.577,34.417-52.181a18.944,18.944,0,0,1,9.443-7.41l51.845-18.513L685.6,208.2Z",
    transform: "translate(-542.529 -85.027)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M729.678,381.864l-5.537,14.091-.69,4.186-3.886,3.834-18.831-4.206,1.934-8.92,11.261-1.69,3.035-7.994Z",
    transform: "translate(-652.641 -166.511)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M731.782,403.754l.54,1.658,20.881,1s-3.737,8.158-4.3,9.809-31.923-9.036-36.417-11.3-1.516-6.043-1.516-6.043l22.727-2.6-1.915,7.476Z",
    transform: "translate(-681.244 -173.346)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M642.486,213.932l3.319,4.7s7.993,13.69-15.365,24.209-36.577,11.11-36.577,11.11l-31.171,59.777L549.9,306.716l24.779-64.222,24.154-22.164,43.654-6.4Z",
    transform: "translate(-487.475 -90.873)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547.987,79.357l18.543-6.113L584,92.364a34.21,34.21,0,0,1,8.925,21.661l1.93,46.636L548.6,152.306l-.611-72.949Z",
    transform: "translate(-434.156 -27.241)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634.11,231.086c-4.844,3.168-10.4,3.237-12.42.154s.277-8.149,5.123-11.317a14.484,14.484,0,0,1,6.416-2.374l20.692-13.163,5.97,9.842-21.033,11.932a14.484,14.484,0,0,1-4.748,4.927Z",
    transform: "translate(-539.162 -86.555)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.608,101.935h0a12.514,12.514,0,0,1,11.181,15.238l-8.634,38.107-39.735,23.23-4.89-12.43,27.1-20.173,1.451-32.064a12.514,12.514,0,0,1,13.526-11.907h0Z",
    transform: "translate(-463.372 -40.198)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.378,
    cy: 16.378,
    rx: 16.378,
    ry: 16.378,
    transform: "translate(104.965 15.461)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.84,399.024l-.018,0a.642.642,0,0,1,.273,0A1.267,1.267,0,0,0,529.84,399.024Z",
    transform: "translate(-359.448 -174.58)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.126,357.594c.138.048.2.071.214.077l-.208-.075Z",
    transform: "translate(-367.597 -155.85)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.534,337.49l.059-.02c-.248.177-.271.132-.166.069.037-.015.066-.031.1-.047Z",
    transform: "translate(-367.984 -146.748)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.187,11.28c-.427.249-1-.128-1.141-.606a2.5,2.5,0,0,1,.178-1.454c.268-.791.529-1.575.8-2.366a12.165,12.165,0,0,1,2.391-4.687c1.849-1.926,4.8-2.417,7.442-2.06,3.4.459,6.753,2.3,8.335,5.344s.906,7.3-1.951,9.2c4.075,4.668,5.49,9.872,5.267,16.057s-6.97,11.887-11.37,16.249c-.982-.593-1.875-3.386-1.333-4.4s-.236-2.187.434-3.125,1.231.555.555-.376c-.427-.587,1.237-1.932.606-2.283-3.067-1.7-4.088-5.522-6.013-8.449A14.389,14.389,0,0,0,425.868,22a9.954,9.954,0,0,0-6.67,1.524,6.25,6.25,0,0,0-2.691,6.039,5.363,5.363,0,0,1,1.116-8.4,8.755,8.755,0,0,1,1.862-8.258c1.983-2.187,10.025-1.811,12.92-1.237l-.223-.383h0l.006-.006Z",
    transform: "translate(-310.946 0)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.65,34.629c3.833.414,6.6,3.737,8.94,6.8,1.345,1.766,2.761,3.718,2.723,5.943-.032,2.245-1.537,4.177-2.257,6.3a9.5,9.5,0,0,0,2.761,10.005,5.511,5.511,0,0,1-6.217-4.317c-.555-3.22,1.888-6.332,1.6-9.591-.255-2.87-2.519-5.076-4.438-7.225s-3.73-4.993-2.844-7.735l-.268-.185h0Z",
    transform: "translate(-306.962 -12.546)",
    fill: "#090814"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndrawBrainstormingGny9);
export default __webpack_public_path__ + "static/media/undraw_brainstorming_gny9.f2250aa0df4fdff7be78b3241f2f3573.svg";
export { ForwardRef as ReactComponent };